export const GRUPOS_FORMULARIO = Object.freeze({
    RENDA: 'RENDA',
    GRUPO_FAMILIAR: 'GRUPO FAMILIAR',
    PARENTE_BENEFICIARIO: 'PARENTE BENEFICIÁRIO',
    OUTROS_TIPOS_DE_RENDA: 'OUTROS TIPOS DE RENDA',
    MORADIA: 'MORADIA',
    VALOR_DISPONIVEL: 'VALOR DISPONÍVEL PARA PAGAMENTO DO CURSO',
    PARTICIPA_COTAS: 'PARTICIPA DO SISTEMA DE COTAS?',
    INSCRICAO_PROCESSO: 'INSCRIÇÃO PROCESSO SELETIVO',
    CURSO_INTERESSE: 'CURSO DE INTERESSE',
    CATEGORIA: 'CATEGORIA',
    POSSUI_ENEM_VETERANO: 'POSSUI ENEM ( VETERANO )',
    POSSUI_BENEFICIO_VETERANO: 'POSSUI BENEFÍCIO NA INSTITUIÇÃO DE ENSINO ( VETERANO )',
    PARTICIPOU_PROCESSO_VETERANO: 'PARTICIPOU DE ALGUM PROCESSO DE SELEÇÃO ANTERIOR ( VETERANO )',
    ESCOLARIDADE: 'ESCOLARIDADE',
    GRUPO_NOTA_ENEM: 'GRUPO NOTA ENEM',
    MOTIVO: 'MOTIVO DA PROCURA DO BENEFÍCIO'
});

const textoNormalizado = (value) => String(value || '').toUpperCase();

export function criarConfiguracaoFormulario(configuracoes = []) {
    const localizar = (nome) => configuracoes.find((item) =>
        textoNormalizado(nome).includes(textoNormalizado(item.grupo))
    );

    return {
        localizar,
        isVisible: (nome) => Boolean(localizar(nome)?.exibir),
        isRequired: (nome) => {
            const item = localizar(nome);
            return Boolean(item?.exibir && item?.obrigatorio);
        }
    };
}

